<template>
    <div class="page">
        <div class="page-header">
            <!-- <div class="container"> -->
                <h1 class="pl-5 title text-light">Información</h1>
            <!-- </div> -->
        </div>
                      
        <b-card no-body class="container mt-2">
            <b-tabs pills card justified class="h6">
                <b-tab v-for="item in tabs" :key="item.id" :title="item.title" :active="item.id==1">
                    <b-card-text>            
                        <p v-if="item.tip==0">{{ item.id }} {{ item.content }}</p>
                        <component v-else :is="item.content"></component>
                    </b-card-text>
                </b-tab>      
            </b-tabs>
        </b-card>

        <!-- <publicidad txt="Ofertas ¡¡ <b>ultima hora</b> !!"/> -->
        
    </div>
</template>

<script>

//import publicidad from '@/components/publicidad.vue';
import condiciones from '@/components/condiciones.vue';
import manuales from '@/components/manuales.vue';
import seguros from '@/components/seguros.vue';
// import cookies from '@/components/cookies.vue';

export default {
    name: 'informacion',
    components: {        
        //publicidad,
        condiciones,manuales,seguros,
        // cookies,

    },
    data() {
        return {
            titulo: 'Información',
            tab_comp: '',
            tabs: [
                { id: 1, title: 'Condiciones Generales', tip: 1, content: 'condiciones' },
                { id: 2, title: 'Manual Operativo', tip: 1, content: 'manuales' },
                { id: 3, title: 'Seguros', tip: 1, content: 'seguros' },                
                // { id: 4, title: 'Cookies', tip: 1, content: 'cookies' },
                
            ],
        }
    },
    created() {
        // if (!this.$store.state.auth.token) {
        //     this.$router.push('/');
        // }
        //console.log('*informacion.created',this.$store.state.auth);
    }

}
</script>